import { useGuard } from "../hooks/useGuard";
import { useRBACStore } from "../zustand/useRBACStore";

export default function RBACUIGuard({ children, requiredPermission, fallback }) {
  const { hasPermission } = useGuard();
  const { currentProfile } = useRBACStore();
  
  if (!hasPermission(requiredPermission, currentProfile?.profileType, currentProfile?.permissions)) {
    return fallback || null;
  }

  return children;
}
